// neurotrader-admin/src/components/YearlyEvolutionChart.js
import React from 'react';
import ReactApexChart from 'react-apexcharts';

const monthNames = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

const YearlyEvolutionChart = ({ data }) => {
    // Prepara os dados para o formato que a ApexCharts espera
    const series = [
        {
            name: 'Comissão ($)',
            type: 'column',
            data: data.map(item => item.commission.toFixed(2))
        },
        {
            name: 'Operações',
            type: 'line',
            data: data.map(item => item.operations)
        },
        {
            name: 'Clientes Ativos',
            type: 'line',
            data: data.map(item => item.clients)
        }
    ];

    const options = {
        chart: {
            height: 350,
            type: 'line', // Tipo base, mas as séries definem os seus próprios
            stacked: false,
            background: 'transparent',
            toolbar: { show: true },
            zoom: { enabled: false },
        },
        theme: { mode: 'dark' },
        dataLabels: { enabled: false },
        stroke: { width: [0, 4, 4], curve: 'smooth' }, // Largura para Coluna, Linha, Linha
        title: { text: 'Evolução Anual', align: 'left', style: { color: '#FFF' } },
        xaxis: {
            categories: data.map(item => monthNames[item.month - 1]),
            labels: { style: { colors: '#8892b0' } }
        },
        yaxis: [ // Eixos Y múltiplos
            { // Eixo da Comissão
                seriesName: 'Comissão ($)',
                axisTicks: { show: true },
                axisBorder: { show: true, color: 'var(--primary-color)' },
                labels: {
                    style: { colors: 'var(--primary-color)' },
                    formatter: (val) => `$${val.toFixed(0)}`
                },
                title: { text: "Comissão ($)", style: { color: 'var(--primary-color)' } },
            },
            { // Eixo das Operações
                seriesName: 'Operações',
                opposite: true, // Coloca este eixo do lado direito
                axisTicks: { show: true },
                axisBorder: { show: true },
                labels: { formatter: (val) => val.toFixed(0) },
                title: { text: "Operações" },
            },
            { // Eixo dos Clientes (compartilha o mesmo eixo das operações)
                seriesName: 'Clientes Ativos',
                show: false, // Oculto para não poluir, mas usa a mesma escala do eixo direito
                opposite: true,
            }
        ],
        tooltip: {
            theme: 'dark',
            fixed: { enabled: false },
            y: {
                formatter: function (val) {
                    return val.toFixed(2);
                }
            },
        },
        legend: { position: 'top', horizontalAlign: 'left', offsetX: 40 }
    };

    return (
        <div className="yearly-chart-container">
            <ReactApexChart options={options} series={series} type="line" height={350} />
        </div>
    );
};

export default YearlyEvolutionChart;